<template>
  <div>

    <b-alert variant="danger" v-if="Object.keys(errors).length > 0" show>
      {{ errors }}
    </b-alert>

    <b-container></b-container>
    <section id="hero">
      <b-container class="search-inputs-wrapper">
        <b-row>
          <b-col cols="12" sm="6">
            <h1 v-html="$t('landings.professionals.title')"></h1>
          </b-col>
        </b-row>
      </b-container>
    </section>

    <b-container>

      <section>
        <h2 v-html="$t('landings.professionals.why.title')"></h2>
        <b-row>
          <b-col v-html="$t('landings.professionals.why.description')"></b-col>
        </b-row>
      </section>

      <section id="why">
        <h2 v-html="$t('landings.professionals.how')"></h2>
        <b-row>
          <b-col>
            <h3 class="mt-3 mb-5" v-html="$t('landings.professionals.how.options.title')"></h3>
            <b-row>
              <b-col cols="12" sm="6" md="4">
                <div>
                  <i class="material-icons">
                    create
                  </i>
                </div>
                {{ $t('landings.professionals.how.options.option1') }}
              </b-col>
              <b-col cols="12" sm="6" md="4">
                <div>
                  <i class="material-icons">
                    fitness_center
                  </i>
                </div>
                {{ $t('landings.professionals.how.options.option2') }}
              </b-col>
              <b-col cols="12" sm="6" md="4">
                <div>
                  <i class="material-icons">
                    email
                  </i>
                </div>
                {{ $t('landings.professionals.how.options.option3') }}
              </b-col>
              <b-col cols="12" sm="6" md="4">
                <div>
                  <i class="material-icons">
                    list_alt
                  </i>
                </div>
                {{ $t('landings.professionals.how.options.option4') }}
              </b-col>
              <b-col cols="12" sm="6" md="4">
                <div>
                  <i class="material-icons">
                    sentiment_satisfied_alt
                  </i>
                </div>
                {{ $t('landings.professionals.how.options.option5') }}
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </section>

    </b-container>

    <section id="communication" class="mt-5">
      <b-container>
        <div class="text">
          <h3>{{ $t('landings.professionals.communication.title') }}</h3>
          <p v-html="$t('landings.professionals.communication.description')"></p>
        </div>
      </b-container>
    </section>

    <b-container v-if="1 === 2">
      <section id="offers">
        <b-row>
          <b-col>
            <h3 class="mt-5 mb-5">We offer you</h3>
            <b-row>
              <b-col cols="6" sm="4" md="3">
                <div>
                  <i class="material-icons">
                    account_circle
                  </i>
                </div>
                <p>Free visibility and marketing as well as clients</p>
                <b-btn variant="info">Read more</b-btn>
              </b-col>
              <b-col cols="6" sm="4" md="3">
                <div>
                  <i class="material-icons">
                    create
                  </i>
                </div>
                <p>Inqueries from customers looking for your service</p>
                <b-btn variant="info">Read more</b-btn>
              </b-col>
              <b-col cols="6" sm="4" md="3">
                <div>
                  <i class="material-icons">
                    library_books
                  </i>
                </div>
                <p>Invoicing service or employment according to your decision</p>
                <b-btn variant="info">Read more</b-btn>
              </b-col>
              <b-col cols="6" sm="4" md="3">
                <div>
                  <i class="material-icons">
                    monetization_on
                  </i>
                </div>
                <p>Additional sales and revenue through supplement, training wear and training gear from our partners. You will accumulate and receive sales commissions by recommending our partners´products of your choise, to your customers</p>
                <b-btn variant="info">Read more</b-btn>
              </b-col>
              <b-col cols="6" sm="4" md="3" offset-md="3">
                <div>
                  <i class="material-icons">
                    visibility
                  </i>
                </div>
                <p>The option of taking part in our Satisfaction Guarantee-program, which in turn will increase your visibility on our page and our social media channels</p>
                <b-btn variant="info">Read more</b-btn>
              </b-col>
              <b-col cols="6" sm="4" md="3">
                <div>
                  <i class="material-icons">
                    insert_emoticon
                  </i>
                </div>
                <p>Increased visibility and notability through positive customer feedback and our 5-star ranking system</p>
                <b-btn variant="info">Read more</b-btn>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </section>
    </b-container>

  </div>
</template>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<script>

  export default {
    name: 'ProfessionalsLanding',
    components: {
    },
    data () {
      return {
        errors: {}
      }
    },
    mounted () {
      // this.$el.addEventListener('click', this.onClose)
    }
  }
</script>

<style lang="scss" scoped>


  #hero {
    position: relative;
    min-height: 500px;
    background: url(https://finefit.s3.eu-north-1.amazonaws.com/images/hero_landing_professionals.jpg) no-repeat center center;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover;
    overflow: visible;

    .search-inputs-wrapper {
      position: absolute;
      top: 70%;
      left: 50%;
      transform: translate(-50%, -70%);
      width: 100%;
      z-index: 10;
    }

    h1 {
      display: block;
      padding: 1rem;
      box-sizing: border-box;
      color: white;
      font-size: 2rem;
      font-weight: bold;
      text-align: left;
      background: rgba(0,0,0,0.5);
    }
  }

  #why {
    i {
      color: #f1a444;
      font-size: 3rem;
      margin: 2rem 0;
    }
  }

  #communication {
    position: relative;
    min-height: 500px;
    background: url(https://finefit.s3.eu-north-1.amazonaws.com/images/footer_landing_professionals.jpg) no-repeat center center;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover;
    overflow: visible;

    .container {
      position: relative;
      min-height: 500px;

      .text {
        position: absolute;
        right: 0;
        bottom: 0;
        width: 50%;
        z-index: 8;

        h3 {
          display: block;
          padding: 1rem;
          box-sizing: border-box;
          color: white;
          font-size: 2rem;
          font-weight: bold;
          text-align: left;
          background: rgba(0,0,0,0.5);
        }

        p {
          display: block;
          padding: 1.2rem;
          box-sizing: border-box;
          color: white;
          font-size: 1rem;
          font-weight: bold;
          text-align: left;
          background: rgba(0,0,0,0.5);
        }

        @include media-breakpoint-down(md) {
          width: 100%;
        }
      }
    }
  }

  #offers {
    i {
      color: #f1a444;
      font-size: 3rem;
      margin: 2rem 0;
    }
  }

  section {
    padding: 1rem 0;
  }

  section.thumbs {
    .col {
      padding: 15px;
    }
    a {
      position: relative;
      color: white !important;
      text-transform: uppercase;
      text-decoration: none;

      span {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        border: 1px solid white;
        padding: 0.5rem;
      }
      img {
        width: 100%;
        height: auto;
      }

      &:hover {
        color: white;
        opacity: .9;
      }
    }
  }

  section#services {
    .row {
      margin-bottom: -30px;
    }
  }

  .nav{
    list-style:none;
    margin-left:0;
  }
  .nav > li,
  .nav > li > a{
    display:inline-block;
    *display:inline;
    zoom:1;
  }
  .stacked > li{
    display:list-item;
  }
  .stacked > li > a{
    display:block;
  }


  .flyout, .flyout-alt {
    position: relative;
  }

  .flyout-content {
    position: absolute;
    top: 100%;
    left: -99999px;
    height: 0;
    overflow: hidden;
    z-index: 999;
  }

  .flyout:hover > .flyout-content {
    left: 0;
  }

  .flyout-alt:hover > .flyout-content {
    top: 0;
    left: 100%;
  }

  .flyout:hover > .flyout-content, .flyout-alt:hover > .flyout-content {
    height: auto;
    overflow: visible;
  }

  ul.services {
    > li {
      width: 50% !important;
      > ul.flyout-content {
        /*position: relative;*/
        /*width: 100%;*/
        left: 100% !important;
        top: 0 !important;
      }
    }
    font-size: 0.8rem;
    font-family: sans-serif;
    li {
      display: block;
      margin: 0;
      width: 100%;
      margin-left: 0.1rem;
    }
    a {
      line-height: 1;
      padding: 1em;
      padding-left: 0;
      background-color: white;
      color: black;
      border-bottom: 2px solid black !important;
      white-space: nowrap;
      i {
        font-size: 0.8rem;
      }
    }
    .flyout:hover > a, .flyout-alt:hover > a,
    a:hover {
      color: white;
      background-color: $primary;
      text-decoration: none;
    }
    .flyout-alt > a:after {
      content: "";
    }
    a {
      border: 0 solid #fff;
    }
    .flyout-content {
      background-color: white;
      a {
        border-bottom-width: 1px;
      }
    }
    > li {
      > a {

      }
      &:first-child > a {
        border: none;
      }
    }
    .flyout-alt:hover > .flyout-content {
      top: -1px;
    }
  }
</style>

<style lang="scss" scoped>


  h2 {

  }
</style>
